export default {"src":"/_next/static/media/Salon.62b29e65.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};